import { loadStripe } from '@stripe/stripe-js';

// This is your publishable key (safe to expose in client-side code)
const stripePromise = loadStripe('pk_live_51SAaNVKCAuEWvMr8riJaSBiYpauFyzG0jOuy2iJOYH4f8qPguQEyFpv7arFiS8A5T1wQwo531JyOekBjTAlftMsO00pJA3K234');

export { stripePromise };